import { useState } from 'react'
import type { DashboardPeriodKey } from './types'

export interface DashboardPeriodState {
  key: DashboardPeriodKey
  from: string | null
  to: string | null
}

export function useDashboardPeriod() {
  const [state, setState] = useState<DashboardPeriodState>({
    key: 'week',
    from: null,
    to: null,
  })

  const setKey = (key: DashboardPeriodKey) =>
    setState((s) => ({
      ...s,
      key,
      from: key === 'custom' ? s.from : null,
      to: key === 'custom' ? s.to : null,
    }))

  const setCustom = (from: string, to: string) => setState({ key: 'custom', from, to })

  return { state, setKey, setCustom }
}
